import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "next" }
const _hoisted_2 = { class: "btns" }
const _hoisted_3 = { class: "coverSetting" }
const _hoisted_4 = { class: "coverSetting_left" }
const _hoisted_5 = { class: "demo-rate-block" }
const _hoisted_6 = { class: "image-slot" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "animate__animated animate__fadeIn app" }
const _hoisted_9 = { class: "app_icon" }
const _hoisted_10 = { class: "app_cover" }
const _hoisted_11 = { class: "author_info" }
const _hoisted_12 = { class: "about" }
const _hoisted_13 = { class: "introduce" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_VueDraggable = _resolveComponent("VueDraggable")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_More = _resolveComponent("More")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_AlarmClock = _resolveComponent("AlarmClock")!
  const _component_Location = _resolveComponent("Location")!
  const _component_dvi = _resolveComponent("dvi")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("edit.cover.title")), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          size: "large",
          onClick: _ctx.handleSave,
          style: {"background":"#4f4f4f","color":"#fff"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("edit.cover.save")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          "label-width": "auto",
          style: {"max-width":"600px"},
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.gameTitle')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.gameTitle,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.gameTitle) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, { label: "游戏创作者" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.author,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.author) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.opening_hours')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.openHour,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.openHour) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.experience_time')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.experienceTime,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.experienceTime) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.begin')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.beginPoint,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.beginPoint) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.end')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.endPoint,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.endPoint) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.walking_distance')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.walk,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.walk) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.estimated_time')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.estimateTime,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.estimateTime) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.Facilities_along_way')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.along,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.along) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.multiplayer_game')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.multiplayer,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.multiplayer) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.player_age')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.playerAge,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.playerAge) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.transportation')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.transportation,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.transportation) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.gameLanguage')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.gameLanguage,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.gameLanguage) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "繁体中文",
                      value: "繁体中文"
                    }),
                    _createVNode(_component_el_option, {
                      label: "简体中文",
                      value: "简体中文"
                    }),
                    _createVNode(_component_el_option, {
                      label: "English",
                      value: "English"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.gameCategory')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.gameClass,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.gameClass) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "单人角色剧本",
                      value: "单人角色剧本"
                    }),
                    _createVNode(_component_el_option, {
                      label: "多人角色剧本",
                      value: "多人角色剧本"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.tag')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.tips,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.tips) = $event)),
                  multiple: "",
                  filterable: "",
                  "allow-create": "",
                  "multiple-limit": "5",
                  "default-first-option": "",
                  placeholder: "请选择作品标签"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.difficulty')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_rate, {
                    modelValue: _ctx.form.difficulty,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.difficulty) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.playTime')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.form.playTime,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.playTime) = $event)),
                  min: 10,
                  max: 120,
                  step: 10
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_alert, {
              title: "封面图最佳比例为4:3",
              type: "warning",
              center: true,
              closable: false
            }),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.gameCover')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "avatar-uploader",
                  action: _ctx.UpdateApi,
                  "show-file-list": false,
                  "on-success": _ctx.handleAvatarSuccess,
                  "before-upload": _ctx.beforeAvatarUpload,
                  limit: 1,
                  "file-list": _ctx.fileList,
                  disabled: _ctx.allowUpload
                }, {
                  default: _withCtx(() => [
                    (_ctx.form.gameCover)
                      ? (_openBlock(), _createBlock(_component_el_image, {
                          key: 0,
                          src: _ctx.form.gameCover,
                          class: "avatar",
                          alt: "",
                          fit: 'contain'
                        }, {
                          error: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_icon_picture)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["src"]))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          class: "avatar-uploader-icon"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Plus)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.allowUpload)
              ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "warning",
                      onClick: _ctx.clearImage
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("settings.clearImg")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.slideshow')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueDraggable, {
                  ref: "el",
                  modelValue: _ctx.fileList2,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.fileList2) = $event)),
                  class: "content"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList2, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: "lunBo"
                      }, [
                        _createVNode(_component_el_image, {
                          src: item.url,
                          fit: 'contain',
                          class: "elImg"
                        }, null, 8, ["src"]),
                        _createElementVNode("span", {
                          class: "clearImg",
                          onClick: ($event: any) => (_ctx.clearImage2(index))
                        }, "删除图片", 8, _hoisted_7)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_upload, {
                  "file-list": _ctx.fileList2,
                  action: _ctx.UpdateApi,
                  "on-success": _ctx.handleAvatarSuccess2,
                  "before-upload": _ctx.beforeAvatarUpload2,
                  "show-file-list": false,
                  "list-type": "picture-card",
                  style: {"margin-top":"10px","margin-left":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "avatar-uploader-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list", "action", "on-success", "before-upload"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.gameDescription')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.gameDesc,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.gameDesc) = $event)),
                  type: "textarea",
                  size: "large",
                  rows: "10",
                  "show-word-limit": "",
                  maxlength: "400"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.research_characteristics')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.features,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.features) = $event)),
                  type: "textarea",
                  size: "large",
                  rows: "10",
                  "show-word-limit": "",
                  maxlength: "400"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"]),
        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "zhanwei4" }, null, -1))
      ]),
      _createVNode(_component_dvi, { class: "coverSetting_right" }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("edit.cover.titleApp")), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", null, [
                _createVNode(_component_el_icon, {
                  size: "20",
                  color: "#fff"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowLeft)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("p", null, [
                _createVNode(_component_el_icon, {
                  size: "20",
                  color: "#fff"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_More)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_image, {
                style: {"height":"100%"},
                src: 
              _ctx.form.gameCover == ''
                ? 'https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493'
                : _ctx.form.gameCover
            ,
                fit: "cover"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", null, _toDisplayString(_ctx.form.gameTitle == "" ? "游戏标题" : _ctx.form.gameTitle), 1),
              _cache[22] || (_cache[22] = _createElementVNode("p", null, [
                _createElementVNode("span"),
                _createElementVNode("span")
              ], -1)),
              _cache[23] || (_cache[23] = _createElementVNode("p", null, null, -1))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("edit.cover.app1")), 1),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, [
                  _createVNode(_component_el_icon, { size: "15" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_QuestionFilled)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("edit.cover.app2")), 1),
                _createElementVNode("span", null, [
                  _createVNode(_component_el_rate, {
                    modelValue: _ctx.form.difficulty,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.difficulty) = $event)),
                    size: "default"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, [
                  _createVNode(_component_el_icon, { size: "15" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AlarmClock)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("edit.cover.app3")) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.form.playTime) + "分钟", 1)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, [
                  _createVNode(_component_el_icon, { size: "15" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Location)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("edit.cover.app4")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("edit.cover.app5")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.form.gameDesc == "" ? "游戏介绍" : _ctx.form.gameDesc), 1)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "zhanwei3" }, null, -1))
  ], 64))
}